<template>
  <div style="padding: 20px">

    <div class="tip">
      <p>需要人工审核的订单根据规则自动分派至对应关联账号进行人工审核。</p>
    </div>

    <!--按钮-->
    <div>
      <el-button class="mybtn-blue2" style="width: 100px"  @click="showAddDialog()">新增</el-button>
    </div>

    <!--标题-->
    <div class="config-title">订单合并规则</div>

    <!--表格-->
    <el-table :data="main$data" v-loading="main$loading" size="medium">
      <el-table-column type="index" label="序号" width="50" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="name" label="规则名称" width="180" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="groups" label="适用订单分组" width="220" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="description" label="说明" width="260" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="states" label="状态" width="100" align="center" header-align="center">
        <template slot-scope="scope">
            <span v-if="scope.row.states == '0'">停用</span>
            <span v-else-if="scope.row.states == '1'" style="color: #29CF87">启用</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" header-align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="table_update(scope.row)">修改</el-button>
          <el-button type="text" @click="table_delete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--dialog 新增、编辑-->
    <el-dialog :title="editDialogType=='add'?'新增订单合并规则':'编辑订单合并规则'"
               :visible.sync="editDialogVisible"
               class="mydialog mydialog_add_order_group"
               :append-to-body="true">
      <el-form :label-position="'right'" label-width="90px" class="myform">
        <input type="hidden" v-model="editData.id">
        <!--/-->
        <el-form-item label="规则名称：">
          <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.name"></el-input>
        </el-form-item>
        <!--/-->
        <el-form-item label="订单分组：">
          <div>选择已设定订单分组</div>
          <el-checkbox-group v-model="editData.groupRule">
            <el-checkbox  v-for="(item,item_idx) in data_orderGroup" :key="item_idx"
                          :label="item.id+''">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!--/-->
        <!--<el-form-item label="规则设置：">-->
          <!--<el-form-item label="时间范围：">-->
            <!--<el-select size="small" v-model="editData.timeRange">-->
              <!--<el-option label="15分钟" value="15"></el-option>-->
              <!--<el-option label="30分钟" value="30"></el-option>-->
              <!--<el-option label="1小时" value="60"></el-option>-->
              <!--<el-option label="2小时" value="120"></el-option>-->
              <!--<el-option label="4小时" value="240"></el-option>-->
              <!--<el-option label="12小时" value="720"></el-option>-->
              <!--<el-option label="24小时" value="1440"></el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="合并规则：">-->
            <!--<el-select size="small" v-model="editData.model">-->
              <!--<el-option v-for="(item,item_idx) in data_mergeRule" :key="item_idx"-->
                         <!--:label="item.value" :value="item.code"></el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
        <!--</el-form-item>-->
        <!--/-->
        <el-form-item label="权重：">
          <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.weight"></el-input>
          <div class="dg-desc">填写数字越大，代表权重越高，优先级越高</div>
        </el-form-item>
        <!--/-->
        <el-form-item label="描述：">
          <el-input size="medium" type="textarea" placeholder="请填写对订单的简要描述" v-model="editData.description"></el-input>
        </el-form-item>
        <!---->
        <el-form-item label="状态：">
          <el-radio-group v-model="editData.states">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="mybtn-blue2" @click="saveDialogData">保存</el-button>
        <el-button @click="editDialogVisible=false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 表格
            main$loading: false,
            main$data: [],
            // 下拉框等数据
            data_orderGroup:[], // 订单分组规则
            data_mergeRule:[],
            // 新增、编辑对话框
            editDialogVisible:false,
            editDialogType:'',
            editData:{ }
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/rule/ordermerge/getList'), {

            }).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$data = [];
                }
                else {
                    self.main$data = res.data.data;
                }
            });
        },
        table_update: function (row) {
            let self = this;

            self.xEui.myloading('加载中...')
            self.xFetch.post(self.xApi('/robot/rule/ordermerge/getDetails'), {
                id:row.id
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                let obj = res.data.data;
                let editData = self.getDefaultEditData();

                editData.id = obj.id;
                editData.name = obj.name;
                editData.groupRule = (obj.groupRule||'').split(',');
                editData.timeRange = obj.timeRange+'';
                editData.model = obj.model;
                editData.weight = obj.weight;
                editData.description = obj.description;
                editData.states = obj.states + '';

                // show dialog
                self.editDialogVisible = true;
                self.editDialogType = 'update';
                self.editData = editData;
            });
        },
        table_delete: function (row) {
            let self = this;
            self.xEui.confirm('','确认要删除该条记录吗？',function(){
                self.xEui.myloading('删除中...')
                self.xFetch.post(self.xApi('/robot/rule/ordermerge/delete'), {
                    id:row.id
                },{xPostType:'form'}).then(function (res) {
                    self.xEui.loading_close();

                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    else{
                        self.xEui.msg_success('删除成功')
                        self.fetchData();
                    }
                });
            })
        },
        getDefaultEditData: function(){
            let self = this;
            let editData = {
                groupRule:[],
                states:'1'
            };
            return editData;
        },
        showAddDialog: function(){
            this.editDialogVisible = true;
            this.editDialogType = 'add';
            this.editData = this.getDefaultEditData();
        },
        saveDialogData: function(){
            let self = this;
            let postData = {
                'id':self.editData.id,
                'name':self.editData.name,
                'groupRule':self.editData.groupRule.join(','),
                'timeRange':self.editData.timeRange,
                'model':self.editData.model,
                'weight':self.editData.weight,
                'description':self.editData.description,
                'states':self.editData.states
            }

            if(!postData.name){
                self.xEui.msg_error('请输入名称')
                return;
            }

            // save
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi(
                    postData.id ? '/robot/rule/ordermerge/update' : '/robot/rule/ordermerge/add'
            ), postData).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                else {
                    self.xEui.msg_success('保存成功')
                    self.editDialogVisible = false;
                    self.fetchData();
                }
            });
        }
    },
    created: function () {
        let self = this;

        // 表格数据
        self.fetchData();

        // 下拉框等数据
        //--订单分组
        self.xFetch.post(self.xApi('/robot/rule/ordergroup/getList'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            let list = [];
            res.data.data.forEach(function (item) {
                if (item.app == '1'/*审核*/ || item.app == '3'/*全部*/) {
                    list.push(item)
                }
            });
            self.data_orderGroup = list;
        });
        //--合并规则
        self.xFetch.post(self.xApi('/robot/common/getMergeRule'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_mergeRule = res.data.data;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-input, .el-select, .el-date-editor.el-input{
    width: 220px;
  }
  .el-textarea{
    width: 370px;
  }
  /*config-title*/
  .config-title{ font-size: 13px;color: #333;font-weight: 700;padding: 30px 0; }
  /*mydialog_add_order_audit_rule*/
  .mydialog_add_order_audit_rule{ }
  .mydialog_add_order_audit_rule .dg-input{ width: 220px }
  .mydialog_add_order_audit_rule .dg-desc{ font-size: 13px;color: #909399;line-height: 30px }
  p{
    margin: 0;
  }
</style>
<style>
  /*mydialog_add_order_audit_rule*/
  .mydialog_add_order_audit_rule .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_audit_rule .el-form-item{margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy/order-merge-rule.vue